<div class="ddd-page" *ngIf="!loading && resource">
  <!-- ===========================================
       BREADCRUMB
       =========================================== -->
  <section class="ddd-breadcrumb-section">
    <div class="ddd-container">
      <div class="ddd-breadcrumb">
        <a routerLink="/digital-downloads">Digital Downloads</a>
        <span class="ddd-separator">/</span>
        <span>{{ resource.title }}</span>
      </div>
    </div>
  </section>

  <!-- ===========================================
       HERO
       =========================================== -->
  <section class="ddd-hero">
    <div class="ddd-container">
      <div class="ddd-hero-grid">
        <!-- LEFT: PREVIEW -->
        <div class="ddd-preview-column">
          <div class="ddd-preview-card">
            <div class="ddd-preview-top">
              <img
                [src]="resource.thumbnail"
                [alt]="resource.title"
                class="ddd-preview-image"
              />
            </div>

            <div class="ddd-preview-body">
              <span class="ddd-category">{{ resource.resource_type }}</span>
              <h2>{{ resource.title }}</h2>
              <p>{{ resource.description }}</p>

              <div class="ddd-file-info">
                <span>{{ resource.resource_type }}</span>
                <span class="ddd-dot"></span>
                <span>{{ resource.file_size }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- RIGHT: CONTENT -->
        <div class="ddd-content-column">
          <span class="ddd-badge">Premium Resource</span>
          <h1>{{ resource.title }}</h1>
          <p class="ddd-description">{{ resource.description }}</p>

          <div class="ddd-meta">
            <div class="ddd-meta-item">
              <i class="ti ti-folder"></i> {{ resource.resource_type }}
            </div>
            <div class="ddd-meta-item">
              <i class="ti ti-bolt"></i> Instant Download
            </div>
          </div>

          <!-- PRICE -->
          <div class="ddd-price-box">
            <span class="ddd-price">£{{ resource.price }}</span>
            <span class="ddd-price-label">One-time payment</span>
          </div>

          <!-- FEATURES -->
          <div class="ddd-features">
            <div><i class="ti ti-check"></i> Instant Download</div>
            <div><i class="ti ti-check"></i> Lifetime Access</div>
            <div><i class="ti ti-check"></i> Printable PDF</div>
            <div><i class="ti ti-check"></i> Expert Prepared</div>
          </div>

          <!-- BUTTONS -->
          <div class="ddd-actions">
            <button
              *ngIf="resource.price > 0"
              class="ddd-buy-btn"
              (click)="openPurchaseModal(resource)"
            >
              Buy &amp; Download
            </button>

            <button
              *ngIf="resource.price == 0"
              class="ddd-buy-btn"
              (click)="downloadFreeResource()"
            >
              Download Now
            </button>

            <button
              class="ddd-secondary-btn"
              (click)="
                selectedResource = resource;
                activeTab = 'existing';
                showModal = true
              "
            >
              Already Purchased?
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ===========================================
       WHAT'S INCLUDED
       =========================================== -->
  <section class="ddd-included-section">
    <div class="ddd-container">
      <div class="ddd-section-heading">
        <span class="ddd-section-tag">Included</span>
        <h2>Everything Included With This Download</h2>
        <p>
          Your purchase gives you lifetime access to a professionally prepared
          resource designed to help students succeed in the 11+ examination.
        </p>
      </div>

      <div class="ddd-included-grid">
        <div class="ddd-include-card">
          <div class="ddd-include-icon"><i class="ti ti-file-text"></i></div>
          <h3>Printable PDF</h3>
          <p>High quality PDF that can be printed as many times as needed.</p>
        </div>

        <div class="ddd-include-card">
          <div class="ddd-include-icon"><i class="ti ti-bolt"></i></div>
          <h3>Instant Access</h3>
          <p>Download immediately after successful payment without waiting.</p>
        </div>

        <div class="ddd-include-card">
          <div class="ddd-include-icon"><i class="ti ti-infinity"></i></div>
          <h3>Lifetime Access</h3>
          <p>Purchase once and download again whenever you need.</p>
        </div>

        <div class="ddd-include-card">
          <div class="ddd-include-icon"><i class="ti ti-target-arrow"></i></div>
          <h3>Exam Focused</h3>
          <p>Carefully designed for current 11+ examination standards.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ===========================================
       WHY CHOOSE THIS RESOURCE
       =========================================== -->
  <section class="ddd-benefits-section">
    <div class="ddd-container">
      <div class="ddd-section-heading">
        <span class="ddd-section-tag">Why Choose Us</span>
        <h2>Created By Experienced 11+ Educators</h2>
        <p>
          Every digital resource is prepared to help students build confidence
          and improve exam performance.
        </p>
      </div>

      <div class="ddd-benefits-grid">
        <div class="ddd-benefit-card">
          <h3>Curriculum Focused</h3>
          <p>
            Questions and exercises closely match modern 11+ examination
            patterns.
          </p>
        </div>
        <div class="ddd-benefit-card">
          <h3>Saves Preparation Time</h3>
          <p>
            Ready-to-use worksheets and practice material without spending hours
            searching.
          </p>
        </div>
        <div class="ddd-benefit-card">
          <h3>Trusted By Families</h3>
          <p>
            Used by hundreds of parents and students preparing for grammar
            school entrance.
          </p>
        </div>
        <div class="ddd-benefit-card">
          <h3>Affordable Learning</h3>
          <p>Premium educational resources at a fraction of tutoring costs.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ===========================================
       RELATED RESOURCES
       =========================================== -->
  <section class="ddd-related-section" *ngIf="relatedResources.length > 0">
    <div class="ddd-container">
      <div class="ddd-section-heading">
        <span class="ddd-section-tag">More Resources</span>
        <h2>You May Also Like</h2>
        <p>
          Explore more premium 11+ preparation resources carefully designed by
          our experienced educators.
        </p>
      </div>

      <div class="ddd-related-grid">
        <div class="ddd-related-card" *ngFor="let item of relatedResources">
          <div class="ddd-related-accent"></div>

          <div class="ddd-related-category">{{ item.resource_type }}</div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>

          <div class="ddd-related-meta">
            <span>{{ item.fileType }}</span>
            <span class="ddd-dot"></span>
            <span>{{ item.fileSize }}</span>
          </div>

          <div class="ddd-related-downloads">
            <i class="ti ti-download"></i> {{ item.downloads }} Downloads
          </div>

          <div class="ddd-related-price">
            <span
              class="ddd-old-price"
              *ngIf="item.salePrice && item.salePrice < item.price"
            >
              £{{ item.price }}
            </span>
            <span class="ddd-current-price"
              >£{{ item.salePrice || item.price }}</span
            >
          </div>

          <a
            class="ddd-related-btn"
            [routerLink]="['/digital-download', item.slug]"
          >
            View Details <i class="ti ti-arrow-right"></i>
          </a>
        </div>
      </div>

      <div class="ddd-view-all">
        <a routerLink="/digital-downloads" class="ddd-view-all-btn"
          >Browse All Resources</a
        >
      </div>
    </div>
  </section>

  <!-- ===========================================
       FAQ SECTION
       =========================================== -->
  <section class="ddd-faq-section">
    <div class="ddd-container">
      <div class="ddd-section-heading">
        <span class="ddd-section-tag">Frequently Asked Questions</span>
        <h2>Questions About This Resource</h2>
        <p>
          Everything you need to know before purchasing this digital download.
        </p>
      </div>

      <div class="ddd-faq-grid">
        <div class="ddd-faq-card">
          <h3>How will I receive this resource?</h3>
          <p>
            Immediately after your payment is completed, you'll receive instant
            access to download this resource. You can also download it again
            anytime using the same email address.
          </p>
        </div>
        <div class="ddd-faq-card">
          <h3>Is this a physical product?</h3>
          <p>
            No. This is a digital product delivered instantly as a downloadable
            PDF file. Nothing will be shipped to your address.
          </p>
        </div>
        <div class="ddd-faq-card">
          <h3>Can I print the worksheets?</h3>
          <p>
            Yes. All resources are supplied in high-quality PDF format and are
            designed for both digital viewing and home printing.
          </p>
        </div>
        <div class="ddd-faq-card">
          <h3>Can I download again later?</h3>
          <p>
            Yes. Your purchase is linked to your email address, allowing you to
            re-download your files whenever you need.
          </p>
        </div>
        <div class="ddd-faq-card">
          <h3>Can I share these files?</h3>
          <p>
            These resources are licensed for personal use only. Sharing,
            redistributing or reselling the files is not permitted.
          </p>
        </div>
        <div class="ddd-faq-card">
          <h3>Are these resources suitable for all 11+ exams?</h3>
          <p>
            Our materials are carefully created to support the major 11+
            examination boards and help children build confidence across core
            topics.
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       PURCHASE MODAL
       ============================================================ -->
  <div class="dd-modal-overlay" *ngIf="showModal" (click)="closeModal()">
    <div class="dd-modal" (click)="$event.stopPropagation()">
      <button class="dd-modal-close" (click)="closeModal()">
        <i class="ti ti-x"></i>
      </button>

      <!-- Tabs -->
      <div class="dd-modal-tabs" *ngIf="!paymentCompleted">
        <button
          [class.active]="activeTab === 'purchase'"
          (click)="activeTab = 'purchase'"
        >
          Purchase
        </button>
        <button
          [class.active]="activeTab === 'existing'"
          (click)="activeTab = 'existing'"
        >
          Already Purchased
        </button>
      </div>

      <!-- ============================================================
           PURCHASE TAB
           ============================================================ -->
      <div
        class="dd-modal-content"
        *ngIf="activeTab === 'purchase' && !paymentCompleted"
      >
        <!-- LEFT SIDE -->
        <div class="dd-modal-left">
          <div class="dd-product-card">
            <div
              class="dd-product-icon"
              [ngClass]="
                'dd-card-icon--' + (selectedResource?.colorKey || 'navy')
              "
            >
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path
                  d="M14 2H6A2 2 0 0 0 4 4V20A2 2 0 0 0 6 22H18A2 2 0 0 0 20 20V8L14 2Z"
                  stroke="currentColor"
                  stroke-width="2"
                ></path>
                <polyline
                  points="14 2 14 8 20 8"
                  stroke="currentColor"
                  stroke-width="2"
                ></polyline>
              </svg>
            </div>

            <div class="dd-product-info">
              <div class="dd-product-category">
                {{ selectedResource?.resource_type }}
              </div>
              <h2 class="dd-product-title">{{ selectedResource?.title }}</h2>
              <p class="dd-product-desc">{{ selectedResource?.description }}</p>
            </div>

            <div class="dd-product-details">
              <div class="dd-product-detail">
                <span>Format</span>
                <strong>{{ selectedResource?.resource_type }}</strong>
              </div>
              <div class="dd-product-detail">
                <span>Delivery</span>
                <strong>Instant</strong>
              </div>
            </div>

            <div class="dd-price-box">
              <span class="dd-modal-price">£{{ selectedResource?.price }}</span>
            </div>

            <ul class="dd-includes-list">
              <li><i class="ti ti-check"></i> Instant Download Access</li>
              <li><i class="ti ti-check"></i> Lifetime Access</li>
              <li><i class="ti ti-check"></i> Printable PDF Format</li>
              <li><i class="ti ti-check"></i> Secure Payment</li>
              <li><i class="ti ti-check"></i> Re-download Anytime</li>
            </ul>
          </div>
        </div>

        <!-- RIGHT SIDE -->
        <div class="dd-modal-right">
          <div class="dd-form-header">
            <h3>Complete Your Purchase</h3>
            <p>Fill in your details and proceed to secure payment.</p>
          </div>

          <div *ngIf="!showPaymentSection">
            <form class="dd-form" (ngSubmit)="continueToPayment()" novalidate>
              <div
                class="dd-form-group"
                [class.dd-error]="formErrors.firstName"
              >
                <label>First Name *</label>
                <input
                  type="text"
                  [(ngModel)]="formData.firstName"
                  name="firstName"
                  placeholder="Enter first name"
                />
                <span class="dd-error-text" *ngIf="formErrors.firstName">{{
                  formErrors.firstName
                }}</span>
              </div>

              <div class="dd-form-group" [class.dd-error]="formErrors.lastName">
                <label>Last Name *</label>
                <input
                  type="text"
                  [(ngModel)]="formData.lastName"
                  name="lastName"
                  placeholder="Enter last name"
                />
                <span class="dd-error-text" *ngIf="formErrors.lastName">{{
                  formErrors.lastName
                }}</span>
              </div>

              <div class="dd-form-group" [class.dd-error]="formErrors.email">
                <label>Email Address *</label>
                <input
                  type="email"
                  [(ngModel)]="formData.email"
                  name="email"
                  placeholder="Enter email address"
                />
                <span class="dd-error-text" *ngIf="formErrors.email">{{
                  formErrors.email
                }}</span>
              </div>

              <div class="dd-form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  [(ngModel)]="formData.phone"
                  name="phone"
                  placeholder="Optional"
                />
              </div>

              <div class="dd-checkbox-wrap">
                <label class="dd-checkbox-label">
                  <input
                    type="checkbox"
                    [(ngModel)]="formData.consent"
                    name="consent"
                  />
                  <span
                    >I agree to receive useful 11+ preparation resources and
                    updates.</span
                  >
                </label>
              </div>

              <div class="dd-order-summary">
                <div class="dd-order-row">
                  <span>Resource</span>
                  <strong>£{{ selectedResource?.price }}</strong>
                </div>
                <div class="dd-order-row dd-order-total">
                  <span>Total</span>
                  <strong>£{{ selectedResource?.price }}</strong>
                </div>
              </div>

              <button
                type="submit"
                class="dd-pay-btn"
                [disabled]="isProcessingPayment"
              >
                <span *ngIf="!isProcessingPayment">Continue to Payment</span>
                <span *ngIf="isProcessingPayment"
                  >Preparing Secure Checkout...</span
                >
              </button>

              <div class="dd-payment-note">
                <i class="ti ti-lock"></i> Secure checkout powered by encrypted
                payment gateway.
              </div>
            </form>
          </div>

          <div *ngIf="showPaymentSection" class="dd-payment-section">
            <div class="dd-form-header">
              <h3>Complete Secure Payment</h3>
              <p>
                Choose PayPal or pay directly using your credit or debit card.
              </p>
            </div>

            <div class="dd-order-summary">
              <div class="dd-order-row">
                <span>Resource</span>
                <strong>{{ selectedResource?.title }}</strong>
              </div>

              <div class="dd-order-row dd-order-total">
                <span>Total</span>
                <strong>£{{ selectedResource?.price }}</strong>
              </div>
            </div>

            <div class="dd-paypal-wrapper">
              <div id="paypal-button-container"></div>

              <div class="dd-payment-divider">
                <span>OR</span>
              </div>

              <div id="card-fields-container"></div>
            </div>

            <button
              type="button"
              class="dd-secondary-btn"
              (click)="showPaymentSection = false"
            >
              ← Back
            </button>
          </div>
        </div>
      </div>

      <!-- ============================================================
           ALREADY PURCHASED TAB
           ============================================================ -->
      <div
        class="dd-existing-tab"
        *ngIf="activeTab === 'existing' && !paymentCompleted"
      >
        <div class="dd-existing-card">
          <h2>Already Purchased?</h2>
          <p>
            Enter the email address used during purchase and we'll instantly
            verify your access.
          </p>

          <div class="dd-existing-form">
            <input
              type="email"
              [(ngModel)]="lookupEmail"
              placeholder="Enter your email"
            />
            <button
              type="button"
              class="dd-check-btn"
              (click)="checkPurchase()"
            >
              Check Purchase
            </button>
          </div>

          <div class="dd-purchase-found" *ngIf="purchaseFound">
            <div class="dd-found-icon"><i class="ti ti-circle-check"></i></div>
            <h3>Purchase Found</h3>
            <p>Your resource is ready for download.</p>
            <a
              [href]="downloadUrl"
              target="_blank"
              class="dd-download-again-btn"
              (click)="trackDownload()"
            >
              Download Resource
            </a>
          </div>

          <div
            class="dd-purchase-not-found"
            *ngIf="purchaseChecked && !purchaseFound"
          >
            <div class="dd-not-found-icon">
              <i class="ti ti-alert-triangle"></i>
            </div>
            <h3>No Purchase Found</h3>
            <p>We couldn't find a purchase associated with that email.</p>
            <button
              type="button"
              class="dd-switch-tab-btn"
              (click)="activeTab = 'purchase'"
            >
              Purchase Resource
            </button>
          </div>
        </div>
      </div>

      <!-- ============================================================
           PAYMENT SUCCESS SCREEN
           ============================================================ -->
      <div class="dd-payment-success" *ngIf="paymentCompleted">
        <div class="dd-success-icon"><i class="ti ti-circle-check"></i></div>
        <h2>Payment Successful</h2>
        <p>
          Thank you for your purchase. Your resource is now ready for download.
        </p>

        <div class="dd-success-resource">
          <div class="dd-success-title">{{ selectedResource?.title }}</div>
          <div class="dd-success-meta">
            {{ selectedResource?.fileType }} <span class="ddd-dot"></span>
            {{ selectedResource?.fileSize }}
          </div>
        </div>

        <a
          [href]="downloadUrl"
          target="_blank"
          class="dd-final-download-btn"
          (click)="trackDownload()"
        >
          Download Now
        </a>

        <p class="dd-success-email">
          A copy of your purchase has been linked to
          <strong>{{ formData.email }}</strong>
        </p>

        <button class="dd-close-success-btn" (click)="closeModal()">
          Continue Browsing
        </button>
      </div>
    </div>
  </div>
</div>
